import { handleActions } from "redux-actions";

const initialState = {
    data: [],
    loading: false,
    error: null,
    //Available null nos dira si el objeto ya esta listo
    //o si esta en default
    onEditionDocument: {
        available: null,
        position: [0, 0],
        slots: [],
        date: "01/01/2019"
    }
}

export default handleActions({
    UPDATE_STATIONS: (state, action) => ({
        ...initialState,
        data: action.payload
    }),
    SAVE_DOCUMENT_INFO: (state, action) => {
        return{
            ...state,
            onEditionDocument: action.payload
        }
    }
}, initialState)